import React from "react";
import { ActionButton } from "../../../../../../../Common/Buttons/ActionButton";
import TextInput from "../../../../../../../Inputs/Text";
import {
  ActionButtonContainer,
  InputContainer,
  LabelContainer,
  LVLabel,
  OptionsContainer,
} from "../__styles__/WidgetSettings";

type OptionsInputProps = {
  options: Array<string>;
  updateOption: (index: number, value: string) => void;
  removeOption: (index: number) => void;
  disabled: boolean;
};

export function OptionsInput({
  options,
  updateOption,
  removeOption,
  disabled,
}: OptionsInputProps) {
  return (
    <div>
      <LabelContainer>
        <LVLabel text="Pill name" />
      </LabelContainer>
      {options.map((option, index) => (
        <OptionsContainer key={`option.${index}`}>
          <InputContainer labelOnly>
            <TextInput
              onChange={value => updateOption(index, value)}
              name={`label.${index}`}
              value={option}
              disabled={disabled}
            />
          </InputContainer>
          <ActionButtonContainer hidden={options.length <= 1 || disabled}>
            <ActionButton icon="x" onClick={() => removeOption(index)} />
          </ActionButtonContainer>
        </OptionsContainer>
      ))}
    </div>
  );
}
